import {ISelectOption} from '@features/orders/interfaces';
import {getFilterSuggestions} from '@features/orders/services/getFilterSuggestions';

export function getRefIds(searchText: string = ''): Promise<ISelectOption[]> {
    return getFilterSuggestions('ref_id', searchText);
}